import { z } from 'zod'

export function withFormattedErrors<T extends (...args: any[]) => any>(
  fn: T
): T {
  return ((...args: Parameters<T>) => {
    try {
      const result: any = fn(...args)

      if (result instanceof Promise) {
        return result.then(
          (x) => x as ReturnType<T>,
          (err) => Promise.reject(formatError(err))
        )
      }

      return result as ReturnType<T>
    } catch (err) {
      throw formatError(err)
    }
  }) as any as T
}

export function formatError(err: any) {
  if (err instanceof z.ZodError) {
    console.error('[OfferKit] invalid arguments', err.format())

    return Object.assign(
      new Error('[OfferKit] invalid arguments'),
      err.format()
    )
  }

  return err
}
